var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.445.002h9.11v17.924H.446z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .025h6.167V10.22H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.963 3.569)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "M7.82.305a.778.778 0 0 0-1.231.95v.002A6.715 6.715 0 0 1 8 5.395v4.198a6.785 6.785 0 0 1-6.778 6.777.778.778 0 0 0 0 1.556 8.343 8.343 0 0 0 8.334-8.333V5.395A8.252 8.252 0 0 0 7.82.305",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.852 10.68)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "M5.698 8.728a6.768 6.768 0 0 1-4.142-6.246V.802A.778.778 0 0 0 0 .802v1.68a8.318 8.318 0 0 0 5.092 7.679.778.778 0 0 0 .606-1.433",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "M1.599 9.322h.043a.778.778 0 0 0 .776-.736 6.78 6.78 0 0 1 10.158-5.492.778.778 0 1 0 .805-1.33l-.026-.016A8.335 8.335 0 0 0 .865 8.503a.775.775 0 0 0 .731.819h.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "M15 13.162V8.964a5.819 5.819 0 0 0-7.63-5.526.778.778 0 0 0 .435 1.494l.047-.016a4.266 4.266 0 0 1 5.59 4.048v4.198a.778.778 0 0 0 1.555 0H15zM5.95 5.026a.776.776 0 0 0-1.097.06l-.001.002A5.8 5.8 0 0 0 3.37 8.964v4.198a5.814 5.814 0 0 0 10.149 3.877.778.778 0 1 0-1.156-1.037 4.26 4.26 0 0 1-7.435-2.84V8.964c0-1.048.386-2.058 1.085-2.839a.78.78 0 0 0-.063-1.099"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "M7.445 13.162a.778.778 0 0 0-1.556 0 3.296 3.296 0 1 0 6.592 0V8.964a3.296 3.296 0 1 0-6.592 0v1.26a.778.778 0 0 0 1.556 0v-1.26a1.74 1.74 0 1 1 3.48 0v4.198a1.74 1.74 0 1 1-3.48 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B4B4",
    d: "M9.963 12.742v-2.518a.778.778 0 0 0-1.556 0v2.518a.778.778 0 0 0 1.556 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.7b3ecad3999b745bf051f68352d706ec.svg";
export { ForwardRef as ReactComponent };